import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcMicOnIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { useVoiceButtonPresenter } from './VoiceButton.presenter';

interface IVoiceButtonProps {
  className?: string;
}

export const VoiceButton: FC<IVoiceButtonProps> = observer(({ className }) => {
  const presenter = useVoiceButtonPresenter();

  return (
    <FAB
      size={'30'}
      className={className}
      onClick={presenter.onStart}
      Icon={IcMicOnIcon}
      theme={'8'}
      isDisabled={presenter.isStarted}
    />
  );
});
